import { Provider } from '@angular/core';
import { provideTransloco } from '@jsverse/transloco';
import { provideTranslocoLocale } from '@jsverse/transloco-locale';

const translocoLocaleConfig = {
  localeConfig: {
    global: {
      date: {
        day: '2-digit',
        month: '2-digit',
        year: 'numeric',
      },
    },
  },
} as const;

interface TranslocoRootOptions {
  readonly production: boolean;
  readonly availableLangs: readonly string[];
  readonly defaultLang: string;
  readonly fallbackLang: string;
}

export function provideTranslocoRoot(
  options: TranslocoRootOptions,
): Provider[] {
  return [
    provideTransloco({
      config: {
        prodMode: options.production,
        availableLangs: [...options.availableLangs],
        defaultLang: options.defaultLang,
        fallbackLang: options.fallbackLang,
        missingHandler: {
          useFallbackTranslation: true,
        },
        reRenderOnLangChange: true,
        flatten: {
          aot: false,
        },
      },
    }),
    provideTranslocoLocale(translocoLocaleConfig),
  ];
}
